import { AlertCircle, CheckCircle } from 'lucide-react';
import type { SignatureSummaryData } from './signatureSummary';

const formatTimestamp = (iso: string) => new Date(iso).toLocaleString();

/**
 * Tooltip body for a task's signature state — rendered inside the status pill's
 * mouseover so the signed/awaiting detail no longer needs standalone pills
 * (ROG-2842).
 */
export function SignatureSummaryTooltip({
  summary,
}: {
  summary: SignatureSummaryData;
}) {
  const { complete, signed, awaiting } = summary;

  if (!signed.length && !awaiting.length && !complete) return null;

  return (
    <div className='space-y-1.5'>
      {signed.length > 0 && (
        <ul className='space-y-1'>
          {signed.map(s => (
            <li key={s.id} className='flex items-start gap-1.5'>
              <CheckCircle
                className='h-3.5 w-3.5 mt-0.5 shrink-0'
                aria-hidden='true'
              />
              <span>
                <span className='font-medium'>{s.name}</span>
                {s.roleLabel ? (
                  <span className='ml-1 text-muted-foreground'>
                    ({s.roleLabel})
                  </span>
                ) : null}
                <span className='block text-muted-foreground'>
                  Signed {formatTimestamp(s.signedAt)}
                </span>
              </span>
            </li>
          ))}
        </ul>
      )}

      {signed.length === 0 && complete && <p>Signed.</p>}

      {awaiting.map(label => (
        <div key={label} className='flex items-center gap-1.5'>
          <AlertCircle className='h-3.5 w-3.5 shrink-0' aria-hidden='true' />
          <span>Awaiting {label}</span>
        </div>
      ))}
    </div>
  );
}
